import Head from '@otovo/shared/components/Head/Head';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import resolveOpenGraphImage from '@otovo/shared/utils/resolveOpenGraphImage';

type BreezeHeadProps = {
  title: string;
  description?: string;
};

const BreezeHead = ({ title, description }: BreezeHeadProps) => {
  const { BU_CONFIG } = useGlobalConfig();
  return (
    <Head
      noindex
      title={title}
      description={description}
      image={resolveOpenGraphImage(BU_CONFIG.type)}
    >
      <link
        rel="shortcut icon"
        type="image/x-icon"
        href={BU_CONFIG.favicon}
        key={`favicon-${BU_CONFIG.company_name}`}
      />
      <link
        href="https://fonts.googleapis.com/css?family=Poppins:400,500,600&display=swap"
        rel="stylesheet"
      />
    </Head>
  );
};

export default BreezeHead;
